import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faImages } from '@fortawesome/free-solid-svg-icons';

const SwitcherAcervo = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname;

    // 1. Definição das Rotas do Acervo Iconográfico
    const isIconografico = path.includes('/admin/iconografico');

    // 2. Definição das Rotas Específicas de Equipamentos
    // (Aquelas que NÃO são globais e NÃO são iconográficas)
    const isEquipamentos = (
        path === '/admin' || 
        path.startsWith('/admin/itens') || 
        (path.startsWith('/admin/inventarios') && !isIconografico) ||
        (path.startsWith('/admin/termos') && !isIconografico) ||
        (path.startsWith('/admin/categorias') && !isIconografico)
    );

    // 3. Áreas Globais (Localização, Usuários, Ajuda)
    // Se o path começar com um desses e não tiver "iconografico", os botões ficam neutros
    const isGlobal = ['/admin/localizacoes', '/admin/usuarios', '/admin/exemplos'].some(route => 
        path.startsWith(route)
    );

    return (
        <div className="switcher-container mb-4">
            <div className="switcher-pills">
                {/* Botão Equipamentos: Ativo apenas se estiver em rotas de itens */}
                <button 
                    className={`switcher-btn ${isEquipamentos ? 'active' : ''}`}
                    onClick={() => navigate('/admin/itens')}
                >
                    <FontAwesomeIcon icon={faBoxOpen} className="me-2" />
                    Acervo de Equipamentos
                </button>

                {/* Botão Iconográfico: Ativo apenas se estiver em rotas iconográficas */}
                <button 
                    className={`switcher-btn ${isIconografico ? 'active' : ''}`}
                    onClick={() => navigate('/admin/iconografico/fotografias')}
                >
                    <FontAwesomeIcon icon={faImages} className="me-2" />
                    Acervo Iconográfico
                </button>
            </div>
        </div>
    );
};

export default SwitcherAcervo;